import { constants } from "@newsela/angelou";

import { pollFooterCss } from "../Poll/Poll.style";

const { colors } = constants;

export const footerCss = (canSeeResults) => ({
  ...pollFooterCss,
  justifyContent: canSeeResults ? "flex-start" : "flex-end",
});

export const editButtonCss = {
  padding: "8px",
  transition: "none",
};

export const editIconCss = {
  path: {
    stroke: colors.ui.core[700],
  },
};

export const editingTextCss = {
  display: "flex",
  alignItems: "center",
  marginRight: "16px",
  gap: "8px",
  color: colors.ui.neutral[500],
  marginBottom: 0,
};

export const editingIconCss = {
  path: {
    stroke: colors.ui.neutral[500],
  },
};

export const cancelEditsButtonCss = {
  padding: "8px",
  color: colors.ui.core[700],
  transition: "none",
};

export const cancelEditsIconCss = {
  marginBottom: "2px",

  path: {
    stroke: colors.ui.core[700],
  },
};
